function getPublicData(response) {
  if (!response || response.code !== 0) {
    throw new Error((response && response.message) || 'The industries service returned an invalid response.')
  }
  return response.data
}

function normalizeIndustryCategoriesResponse(response) {
  const data = getPublicData(response)
  if (!Array.isArray(data)) throw new Error('The industries service returned an invalid response.')
  return data
}

function normalizeIndustryTopicsResponse(response) {
  const data = getPublicData(response)
  if (!Array.isArray(data)) throw new Error('The industries service returned an invalid response.')
  return data
}

function normalizeIndustryDetailResponse(response) {
  const data = getPublicData(response)
  if (!data || !data.id || !data.categoryId) {
    throw new Error('The industries service returned an invalid response.')
  }
  return data
}

function buildIndustriesPath(categoryId) {
  return `/industries/${encodeURIComponent(String(categoryId))}`
}

function resolveIndustryLanguagePath(categories) {
  const category = Array.isArray(categories) ? categories[0] : null
  return category && category.categoryId ? buildIndustriesPath(category.categoryId) : '/'
}

function buildIndustryDetailPath(categoryId, topicId) {
  return `${buildIndustriesPath(categoryId)}/${encodeURIComponent(String(topicId))}`
}

function getRecommendedProductLinkUrl(value) {
  const linkUrl = typeof value === 'string' ? value.trim() : ''
  if (!linkUrl) return null
  try {
    const parsed = new URL(linkUrl)
    return ['http:', 'https:'].includes(parsed.protocol) && parsed.hostname ? linkUrl : null
  } catch {
    return null
  }
}

function mapHomeIndustryCards(categories) {
  return categories.map((category) => ({
    slot: category.position,
    categoryId: category.categoryId,
    title: category.title,
    description: category.description,
    coverUrl: category.heroImage,
    link: buildIndustriesPath(category.categoryId)
  }))
}

function sanitizeIndustryRichText(value) {
  const html = typeof value === 'string' ? value : ''
  if (!html || typeof document === 'undefined') return html
  const template = document.createElement('template')
  template.innerHTML = html
  template.content.querySelectorAll('script,style,object,embed,link,meta').forEach((node) => node.remove())
  template.content.querySelectorAll('*').forEach((node) => {
    Array.from(node.attributes).forEach((attribute) => {
      const name = attribute.name.toLowerCase()
      const value = attribute.value.trim().toLowerCase()
      if (name.startsWith('on') || ((name === 'src' || name === 'href') && value.startsWith('javascript:'))) {
        node.removeAttribute(attribute.name)
      }
    })
  })
  return template.innerHTML
}

module.exports = {
  buildIndustryDetailPath,
  buildIndustriesPath,
  getRecommendedProductLinkUrl,
  resolveIndustryLanguagePath,
  mapHomeIndustryCards,
  normalizeIndustryCategoriesResponse,
  normalizeIndustryDetailResponse,
  normalizeIndustryTopicsResponse,
  sanitizeIndustryRichText
}
